export default "__VITE_ASSET__BPgUCtrJ__"